import { useEffect, useState } from 'react'

const QUERY = '(prefers-reduced-motion: reduce)'

const matchesQuery = () =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(QUERY).matches
    : false

/**
 * Tracks the user's "reduce motion" system setting.
 *
 * @returns {boolean} True while the user prefers reduced motion.
 */
export default function usePrefersReducedMotion() {
  const [reducedMotion, setReducedMotion] = useState(matchesQuery)

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return undefined

    const mediaQuery = window.matchMedia(QUERY)
    const handleChange = () => setReducedMotion(mediaQuery.matches)
    mediaQuery.addEventListener('change', handleChange)
    return () => mediaQuery.removeEventListener('change', handleChange)
  }, [])

  return reducedMotion
}
